import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/modules/shared/services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UsersService } from 'src/app/modules/shared/services/users.service';
import { NotificationsService } from 'src/app/modules/shared/services/notifications.service';

@Component({
    selector: 'app-password-recovery',
    templateUrl: './password-recovery.component.html'
})
export class PasswordRecoveryComponent implements OnInit {

    public changeCurrentUserPasswordForm = { token: "", newPassword: "", newPasswordConfirmation: "" };

    constructor(
        public authenticationService: AuthenticationService
        , private router: Router
        , private route: ActivatedRoute
        , private usersService: UsersService
        , private notifications: NotificationsService) { }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.changeCurrentUserPasswordForm.token = params["token"];
        });
    }

    submitChangeCurrentUserPasswordForm(form) {
        if (!form.valid) {
            Object.keys(form.controls).forEach(key => form.controls[key].markAsDirty());
            return;
        }

        this.usersService.recoverUserPasswordByToken(this.changeCurrentUserPasswordForm).subscribe(response => {
            if (!response.success) {
                this.notifications.errors(response.payload.messages);
                return;
            }
            this.notifications.success("Senha alterada com sucesso.");
            this.router.navigate(["/"]);
        });
    };
}
